<!--
 * @Description: 产品页
 * @Author: zml
 * @Date: 2022-10-27 09:06:05
 * @LastEditors: xie
 * @LastEditTime: 2024-07-31 14:48:35
-->
<template>
  <div>
    <component :is="componentName"></component>
  </div>
</template>
<script>
import mixins from '@/utils/mixins'
export default {
  name: 'productPage',
  mixins: [mixins],
  data() {
    return {
      componentName: ''
    }
  },
  created() {
    this.initDom()
  },
  methods: {
    initDom() {
      switch (this.$templates()) {
        case 'themeTemplateOne':
          this.componentName = 'pageProductOne'
          break
        case 'themeTemplateTwo':
          this.componentName = 'pageProductTow'
          break
        case 'themeTemplateThree':
          this.componentName = 'pageProductThree'
          break
        case 'themeTemplateFour':
          this.componentName = 'pageProductFour'
          break
        case 'themeTemplateFive':
          this.componentName = 'pageProductFive'
          break
        case 'themeTemplateSix':
          this.componentName = 'pageProductSix'
          break
        case 'themeTemplateSeven':
          this.componentName = 'pageProductSeven'
          break
        case 'themeTemplateEight':
          this.componentName = 'pageProductEight'
          break
        case 'themeTemplateNine':
          this.componentName = 'pageProductNine'
          break
        case 'themeTemplateTen':
          this.componentName = 'pageProductTen'
          break
        default:
          this.componentName = ''
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>